"use client";

import { useAuth } from "@clerk/nextjs";
import { useCallback } from "react";
import { mutate as globalMutate } from "swr";

// useDispatch wraps the /api/v1/dispatch endpoints. After the data-model
// rewrite these all operate on a load_id (the driver-trip layer), not a
// delivery_id — the dispatcher acts on a Load, never a Delivery.
export function useDispatch() {
  const { getToken } = useAuth();

  const assign = useCallback(
    async (loadId: string, driverId: string) => {
      const token = await getToken();
      const res = await fetch("/api/v1/dispatch/assign", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          load_id: loadId,
          driver_id: driverId,
        }),
      });
      if (!res.ok) throw new Error((await res.json()).error);
      await globalMutate(() => true);
    },
    [getToken],
  );

  const unassign = useCallback(
    async (loadId: string) => {
      const token = await getToken();
      const res = await fetch("/api/v1/dispatch/unassign", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ load_id: loadId }),
      });
      if (!res.ok) throw new Error((await res.json()).error);
      await globalMutate(() => true);
    },
    [getToken],
  );

  const overflow = useCallback(
    async (loadId: string) => {
      const token = await getToken();
      const res = await fetch("/api/v1/dispatch/overflow", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ load_id: loadId }),
      });
      if (!res.ok) throw new Error((await res.json()).error);
      await globalMutate(() => true);
    },
    [getToken],
  );

  return { assign, unassign, overflow };
}
